import toast from "react-hot-toast";
import usePut from "../put/usePut";
import { useNavigate } from "react-router-dom";
import { throwError } from "../../utility/errorHandler";

const useSetPassword = () => {
  let navigate = useNavigate();
  const { handleAuth: setPassword } = usePut({
    url: "set_new_password",
    onSuccess: (res) => {
      toast.success("Password Set Successfully");
        navigate("/login", { replace: true });
    },
    onError: (err) => {
      if (err.response.status === 400) {
        toast.error("Something went wrong");
      } else {
        throwError(err);
      }
    },
  });

  const handleSetPassword = (data) => {
    setPassword.mutate(data);
  };

  return { setPassword, handleSetPassword };
};

export default useSetPassword;
